import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmailConfirmation } from '../../../security/models';
import { RoutingService } from '../../../security/services/routing.service';
import { SecurityService } from '../../../security/services/security.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css'],
})
export class ConfirmEmailComponent implements OnInit {
  emailConfirmation: EmailConfirmation = new EmailConfirmation();
  title: string = '';
  body: string = '';
  showResendConfirmationEmailButton: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private accountService: SecurityService,
    private routingService: RoutingService,
    @Inject('IMAGES_URL') public imagesUrl: string
  ) {}

  navigateToHome() {
    this.routingService.navigateHome();
  }

  resendConfirmationEmail() {
    if (this.emailConfirmation && this.emailConfirmation.email) {
      this.accountService.sendConfirmationEmail(this.emailConfirmation).subscribe(
        (res: any) => {
          this.showResendConfirmationEmailButton = false;
          this.title = 'Correo de confirmación reenviado';
          this.body = '¡Listo! Te enviamos un correo de confirmación nuevo para que puedas finalizar tu proceso de registro.';
        },
        (err: any) => {}
      );
    }
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.token) this.emailConfirmation.token = decodeURIComponent(params.token);
      if (params.email) this.emailConfirmation.email = params.email;

      this.accountService.isEmailConfirmed(this.emailConfirmation).subscribe((res: boolean) => {
        if (res) {
          this.title = 'Tu correo ya ha sido registrado.';
          this.body = 'Estas listo para iniciar sesión.';
        } else {
          this.accountService.confirmAccount(this.emailConfirmation).subscribe(
            (res) => {
              this.title = '¡Haz completado tu registro!';
              this.body = 'Estas listo para iniciar sesión.';
            },
            (err) => {
              this.showResendConfirmationEmailButton = true;
              if (err.error.errors && err.error.errors.length > 0 && err.error.errors[0].code == 'InvalidToken') {
                this.title = 'Correo de confirmación vencido';
                this.body = 'Este correo de confirmación ha vencido, presiona el botón para recibir uno nuevo.';
              } else {
                this.title = '¡Error al completar tu registro!';
                this.body = 'Estamos revisando el problema y te contactaremos pronto.';
              }
            }
          );
        }
      });
    });
  }
}
